<template>
	<div class="plan">

		<span class="custom-btn-save" v-if="_updateTime">最近一次交付时间：<span class="mr15">{{_updateTime}}</span><span class="important">文件交付后再次修改数据用户端会同步更新</span></span>

		<vue-editor v-model="content" :editorToolbar="customToolbar" @text-change="autoSave" :disabled="!editable||editLock"></vue-editor>

		<div class="op-box" v-if="!editLock">
			<a href="javascript:;" class="op-btn deliver-btn" :title="!editable?'已完成或已退款的订单不能进行此操作':''" :class="{'disabled':!editable}" @click="saveCareerPlan">保存</a>
			<a href="javascript:;" class="op-btn export-btn" @click="calloutCancelSaveModal">取消</a>
		</div>

		<div class="op-box" v-if="editLock">
			<a href="javascript:;" class="op-btn deliver-btn" :title="!editable?'已完成或已退款的订单不能进行此操作':''" :class="{'disabled':!editable}" @click="$emit('askToDelivery')">交付</a>
			<a href="javascript:;" class="op-btn export-btn" @click="$emit('askToExport')">导出</a>
			<a href="javascript:;" class="op-btn edit-btn" @click="unlockEditor">修改</a>
		</div>

		<el-dialog :visible="showCancelModal" width="30%" @close="showCancelModal = false">
			<span>确定取消本次编辑？</span>
			<span slot="footer" class="dialog-footer">
    <el-button @click="showCancelModal = false">取 消</el-button>
    <el-button type="primary" @click="cancelSave">确 定</el-button>
  </span>
		</el-dialog>

	</div>
</template>

<script>
	import { httpCareerPlanGet, httpCareerPlanAdd, httpCareerPlanEdit } from '@/api/orderDetails'

	import { VueEditor } from 'vue2-editor'
	export default {
		name: 'PlanEditor',
		components: {
			VueEditor
		},
		props: {
			orderId: {
				required: true
			},
			planId: {
				required: false
			},
			orderDetailId: {
				required: false
			},
			editable: {
				type: Boolean,
				required: true
			},
			dataSource: {
				required: false
			}
		},
		data() {
			return {
				id: '',
				timer: '',
				counter: '', //计数器
				timerLock: true,
				content: ``,
				contentCopy: ``,
				customToolbar: [
					['bold'],
					[{
						'list': 'ordered'
					}]
				],
				theme: 'snow',
				editLock: false,
				showCancelModal: false
			}
		},
		computed: {
			_updateTime() {
				if(this.dataSource.length) {

					for(let i = 0; i < this.dataSource.length; i++) {
						if(this.dataSource[i].serviceItemId == 2) {
							return this.dataSource[i].deliverTime;
							break;
						}
					}
				}
			}
		},
		mounted() {
			this.careerPlanGet();
		},
		methods: {
			//取消保存编辑
			calloutCancelSaveModal() {
				this.showCancelModal = true;
			},

			//取消保存
			cancelSave() {
				this.content = this.contentCopy;
				this.showCancelModal = false;
				this.editLock = true;
			},

			//切换到编辑模式
			unlockEditor() {
				this.contentCopy = this.content;
				this.editLock = false;
			},

			//保存职业生涯规划
			saveCareerPlan() {
				let oData = this.buildData();
				if(!this.editable) return;

				if(this.content.length == 0) {
					this.$message({
						type: 'warning',
						message: '请输入职业生涯规划内容',
						duration: 800
					});
					return;
				}

				if(this.id == 0) {
					this.doCareerPlanAdd(oData);
				} else {
					this.doCareerPlanEdit(oData);
				}
				this.editLock = true;
			},

			//添加新的职业规划
			doCareerPlanAdd(data) {
				httpCareerPlanAdd(data).then(r => {
					//console.log(r);
					if(r.success) {
						this.$message({
							type: 'success',
							message: '保存成功',
							duration: 800
						});
						this.id = r.data.id;
					} else {
						this.$message.error("保存失败，请 稍后再试");
					}

				}).catch(err => {
					console.log(err);
					this.$message.error("保存失败，请 稍后再试");
				})
			},

			//编辑现有的职业规划
			doCareerPlanEdit(data) {
				httpCareerPlanEdit(data).then(r => {
					//console.log(r);
					if(r.success) {
						this.$message({
							type: 'success',
							message: '已为您保存当前内容',
							duration: 800
						});
					} else {
						this.$message.error("保存失败，请 稍后再试");
					}

				}).catch(err => {
					console.log(err);
					this.$message.error("保存失败，请 稍后再试");
				})
			},

			buildData() {
				let oData = {
					orderId: this.orderId,
					content: this.content
				};

				if(this.id == 0) {
					const tempObj = {
						orderDetailId: this.orderDetailId
					};
					Object.assign(oData, tempObj);
				} else {
					const tempObj = {
						id: this.id
					};
					Object.assign(oData, tempObj);
				}

				return oData;
			},

			//自动保存机制
			autoSave() {
				//每十五秒自动保存一次
				//const d = new Date();
				//const nowTime = d.getTime();
				//				if(nowTime - this.timer >= 15000 && !this.timerLock) {
				//					this.timer = nowTime;
				//
				//					this.$message({
				//						type: 'success',
				//						message: '已为您自动保存当前内容',
				//						duration: 800
				//					})
				//					//调用保存方法
				//				}

				//每多编辑50字就保存内容
				//				const counter_now = this.content.length;
				//				if(counter_now - this.counter >= 50 && !this.timerLock) {
				//					this.counter = counter_now;
				//					this.saveCareerPlan();
				//				}

			},

			//获取职业生涯规划
			careerPlanGet() {
				const orderId = this.orderId;
				httpCareerPlanGet(orderId).then(r => {
					//console.log(r);
					if(r.success) {
						this.content = r.data.content || '';
						this.id = r.data.id || 0;
						if(r.data.content && r.data.content.length) {
							this.editLock = true;
						}
						//						setTimeout(() => {
						//							this.timerLock = false;
						//							this.counter = this.content.length || 0;
						//						}, 5000)
					}
				}).catch(err => {
					console.log(err);
					this.$notify({
						type: 'error',
						title: '提示',
						message: '职业生涯原始数据获取失败'
					});
				});
			}
		} //methods结束标记
	}
</script>

<style scoped lang='less'>
	.plan {
		position: relative;
		min-height: 600px;
		.custom-btn-save {
			position: absolute;
			top: 16px;
			right: 10px;
			color: #999;
			font-size: 12px;
		}
	}
	
	.op-box {
		margin: 20px 0;
	}
	
	.op-btn {
		display: block;
		float: left;
		width: 70px;
		line-height: 30px;
		text-align: center;
		font-size: 14px;
		border-radius: 2px;
		margin-right: 8px;
		&.export-btn {
			background-color: #eee;
			color: #333;
		}
		&.deliver-btn {
			background-color: #3B87FF;
			color: #fff;
		}
		&.disabled {
			cursor: not-allowed;
		}
		&.edit-btn {
			color: #333;
		}
	}
	
	.mr15 {
		margin-right: 15px;
	}
</style>


// WEBPACK FOOTER //
// src/components/Common/PlanEditor.vue